// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
        apiKey: 'AIzaSyCNtoZtIasSTowRz1LDAU0sN2AI3-K3jM8',
        authDomain: 'the-scoreboard-19a2a.firebaseapp.com',
        projectId: 'the-scoreboard-19a2a',
        storageBucket: 'the-scoreboard-19a2a.appspot.com',
        messagingSenderId: '1039981594581',
        appId: '1:1039981594581:web:5e5175c21ccdb626d95f5c'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
